import { GlobalAnalyticsContext } from 'frontastic/hooks/useGlobalContext/types';

interface AddContextOptions {
  includeUserData?: boolean;
}

/**
 * Adds global context to event parameters for consistent user identification
 */
export const addGlobalContext = (
  eventParams: Record<string, any>,
  globalContext: GlobalAnalyticsContext,
  options: AddContextOptions = {},
): Record<string, any> => {
  const { includeUserData = true } = options;

  const enriched = { ...eventParams };

  if (includeUserData) {
    enriched.ecomm_customer_id = globalContext.ecomm_customer_id;
    enriched.user_hashed_email = globalContext.user_hashed_email;
    enriched.login_state = globalContext.login_state;
    enriched.cart_id = globalContext.cart_id;
  }

  return enriched;
};
